import { useState as r, useEffect as s } from "react";
const a = 300;
function f(e, t = a) {
  const [o, u] = r(e);
  return s(() => {
    const n = setTimeout(() => {
      u(e);
    }, t);
    return () => clearTimeout(n);
  }, [e, t]), o;
}
export {
  f as default
};
